import { getLoggingModuleOptions, processLoggers } from './config.js';

var isDebuggingLogging = function isDebuggingLogging() {
  return getLoggingModuleOptions().debug;
};
/**
 * Logs an error event
 * @param {string} error Error message
 * @param {object} data Additional data for tbe event
 */


var logError = function logError(error, data) {
  if (isDebuggingLogging()) {
    console.log("logging module logError event:", error, data);
  }

  processLoggers(function (logger) {
    if (logger.logError) {
      logger.logError(error, data);
    }
  });
};
/**
 * Logs a navigation event
 * @param {string} location New location
 * @param {object} data Additional data for tbe event
 */


var logNavigation = function logNavigation(location, data) {
  if (isDebuggingLogging()) {
    console.log("logging module logNavigation event:", location, data);
  }

  processLoggers(function (logger) {
    if (logger.logNavigation) {
      logger.logNavigation(location, data);
    }
  });
};
/**
 * Sets the current user for logged events
 * @param {string} id User ID
 * @param {object} data Additional data for the user
 */


var setUserIdentity = function setUserIdentity(id, data) {
  if (isDebuggingLogging()) {
    console.log("logging module setUserIdentity event:", id, data);
  }

  processLoggers(function (logger) {
    if (logger.setUserIdentity) {
      logger.setUserIdentity(id, data);
    }
  });
};
/**
 * Resets the current user for logged events
 */


var clearUserIdentity = function clearUserIdentity() {
  if (isDebuggingLogging()) {
    console.log("logging module clearUserIdentity event");
  }

  processLoggers(function (logger) {
    if (logger.clearUserIdentity) {
      logger.clearUserIdentity();
    }
  });
};

export { clearUserIdentity, logError, logNavigation, setUserIdentity };
